import { Badge } from '@nexelem/components';
import { useStore } from 'zustand';
import { useCustomTranslation } from '../../../../hooks';
import { HeaderProps } from '../../../organisms/FilteredGridPage/types';

type ActiveFilterProps = Pick<HeaderProps, 'store'>;

export const ActiveFilterBadge = ({ store }: ActiveFilterProps) => {
  const activeFilter = useStore(store, (state) => state.settings.find((_) => _.id === state.activeId));
  const { tWrapper } = useCustomTranslation('components.filters.activeFilter');

  if (activeFilter) {
    return <Badge variant="highlighted">{tWrapper('badge', activeFilter)}</Badge>;
  }
  return null;
};
